module.exports = __webpack_public_path__ + "static/media/middleToHigh.d1ad491b.svg";